import { useQuery } from '@apollo/client';

import COMPANY_BILLING_QUERY from './gql/CompanyBillingStatusQuery.graphql.js';

const useCompanyBillingStatus = () => {
  const { loading, error, data, refetch } = useQuery(COMPANY_BILLING_QUERY);

  const { plan, featureSet, limitSet, ...company } = data?.viewer?.company ?? {};
  const availablePlans = company?.availablePlans ?? [];

  return {
    loading,
    error,
    refetch,
    currentPlan: plan,
    featureSet,
    limitSet,
    company,
    availablePlans,
  };
};

export default useCompanyBillingStatus;
